<card-expanding [formGroup]="form" [(expanded)]="expanded">
  <span header-title>{{'cards.clients.client_details.title' | translate}}</span>
  <div header-actions>
    <ng-container *ngIf="isClient" [ngSwitch]="edit">
      <ng-container *ngSwitchCase="false">
        <div class="align-center flex">
          <lxm-button
            class="ml15"
            type="beige"
            icon="edit"
            title="action.edit"
            (click)="toggleEdit()"
            *ngIf="canEdit"
          ></lxm-button>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="true">
        <div class="align-center flex">
          <lxm-button
            class="ml15"
            type="grey"
            icon="back"
            label="action.cancel"
            (click)="toggleEdit()"
          >
          </lxm-button>
          <lxm-button
            class="ml15"
            type="beige"
            icon="save"
            label="action.save"
            [loading]="saveLoading"
            (click)="save()"
            buttonType="submit"
          ></lxm-button>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div body>
    <div class="row">
      <div class="col-12 no-padding">
        <form-field
          [readonly]="!edit"
          label="enums.TenantField.RegNo"
          for="clientRegCode"
          [required]="edit"
        >
          <lxm-select
            lxm-select
            for="clientAc"
            url="api/clients/ac/"
            (clear)="onAcClear($event)"
            [readonly]="!edit"
            placeholder="{{ 'cards.clients.new.label.search_placeholder' | translate }}"
            [labelFn]="getLabel"
            [isTranslated]="true"
            [addTag]="addNewCompany"
            [addTagText]="'register.about_company.foreign_company' | translate"
          >
          </lxm-select>
          <validation-errors for="clientRegCode"></validation-errors>
        </form-field>

        <form-field label="enums.TenantField.Address" [required]="edit">
          <lxm-gmap-input
            input
            class="flex-1"
            placeholder="components.google_maps.location_search_placeholder"
            googlePlaceFor="clientAddress"
            [readonly]="!edit || form.value.clientAc?.source"
            for="clientAddressText"
          >
          </lxm-gmap-input>
          <validation-errors
            for="address"
            aliasTo="clientAddressText"
          ></validation-errors>
        </form-field>

        <form-field
          [readonly]="!edit || form.value.clientAc?.source"
          label="enums.TenantField.KmkrNr"
          for="clientKMKR"
          type="input-text"
        >
          <validation-errors for="clientKMKR"></validation-errors>
        </form-field>

        <form-field
          [readonly]="!edit || form.value.clientAc?.source"
          label="enums.TenantField.IsFIEOrForeign"
        >
          <slide-toggle
            toggle
            for="clientIsFIEOrForeign"
            [readonly]="!edit"
          ></slide-toggle>
          <validation-errors for="clientIsFIEOrForeign"></validation-errors>
        </form-field>
      </div>
    </div>
  </div>
</card-expanding>
